// This is an example of functional component. The old class component is in components/Navbar.js
import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Container, Row, Col, Image, Figure } from "react-bootstrap";
import { introductionTable, aboutDetailsTable } from "../../firebase/content";
import Editable from "../../components/Editable";
import EditableImage from "../../components/EditableImage";
import "./About.scss";

export default function About({ editable = false }) {
  const content = useSelector((state) => state.content);
  const images = useSelector((state) => state.images);

  const imageUrl = (imageName) =>
    (images.find((img) => img.name === imageName) || {}).url;

  const onInput = (obj, key) => (text) => {
    obj[key] = text;
  };

  let intro = content?.[introductionTable] || {};
  const aboutDetails = content?.[aboutDetailsTable] || [];

  return (
    <div className="about-section" id="about">
      <div className="about-section-welcome">
        <h1>VỀ CHÚNG TÔI</h1>
        <section className="welcome-content">
          {(intro.text || []).map((text) => {
            return (
              <Editable
                editable={editable}
                key={text.id}
                object={text}
                field="line"
              >
                <p>{text.line}</p>
              </Editable>
            );
          })}
          <Editable editable={editable} object={intro} field="signature">
            <p className="signature">{intro.signature}</p>
          </Editable>
        </section>
      </div>
      <Container className="about-content">
        <Row>
          {aboutDetails.map((about) => {
            return (
              <Col className="image-hover" key={about.id}>
                <Figure>
                  <EditableImage editable={editable} object={about}>
                    {({ url, select }) => {
                      return (
                        <Image
                          src={url || imageUrl(about?.image)}
                          onClick={select}
                        />
                      );
                    }}
                  </EditableImage>
                </Figure>
                <Editable editable={editable} onInput={onInput(about, "text")}>
                  <p>{about.text}</p>
                </Editable>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}

About.prototype = {
  editable: PropTypes.bool,
};
